import React from "react";
import { Bounce, Fade } from "react-awesome-reveal";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <>
      <style>{`
        .footer {
          background: linear-gradient(145deg, #0f172a, #051f4bff);
          color: #e2e8f0;
          padding: 70px 20px 30px;
          font-family: 'Poppins', sans-serif;
          position: relative;
          overflow: hidden;
        }

        /* Decorative glowing gradient background */
        .footer::before {
          content: "";
          position: absolute;
          top: -100px;
          left: -100px;
          width: 400px;   
          height: 400px;
          background: linear-gradient(circle, rgba(31,38,97,0.8), transparent 30%);
          filter: blur(100px);
          z-index: 0;
        }
        .footer::after {
          content: "";
          position: absolute;
          bottom: -120px;
          right: -120px;
          width: 400px;
          height: 400px;
          background: radial-gradient(circle, rgba(68, 198, 224, 0.7), transparent 70%);
          filter: blur(120px);
          z-index: 0;
        }

        .footer-container {
          max-width: 1200px;
          margin: auto;
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
          gap: 40px;
          position: relative;
          z-index: 1;
        }

        .footer h3 {
          font-size: 1.4rem;
          color: #fff;
          margin-bottom: 18px;
          font-weight: 600;
          position: relative;
        }
        .footer h3::after {
          content: "";
          display: block;
          width: 45px;
          height: 3px;
          margin-top: 6px;
          border-radius: 2px;
          background: linear-gradient(90deg, #1F2661, #28e5e2ff);
        }

        .footer p {
          font-size: 0.95rem;
          line-height: 1.7;
          color: #cbd5e1;
        }

        .footer-links a {
          display: block;
          color: #94a3b8;
          text-decoration: none;
          margin-bottom: 10px;
          font-size: 0.95rem;
          transition: all 0.3s ease;
        }
        .footer-links a:hover {
          color: #0ef2f2ff;
          transform: translateX(5px);
        }

        .social-icons {
          display: flex;
          gap: 12px;
          margin-top: 15px;
        }
        .social-icons a {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 40px;
          height: 40px;
          background: rgba(255,255,255,0.08);
          border: 1px solid rgba(255,255,255,0.1);
          backdrop-filter: blur(8px);
          color: white;
          border-radius: 50%;
          font-size: 1.2rem;
          transition: all 0.3s ease;
        }
        .social-icons a:hover {
          background: linear-gradient(15deg, #1F2661, #14f7fbff);
          transform: scale(1.1) translateY(-4px);
          box-shadow: 0 0 12px #14f7fbff;
        }

        .footer-bottom {
          text-align: center;
          font-size: 0.85rem;
          margin-top: 50px;
          color: #94a3b8;
          border-top: 1px solid rgba(255,255,255,0.1);
          padding-top: 18px;
          position: relative;
          z-index: 1;
        }
          a {
          text-decoration: none;
          }

          .b2{
          margin-top:50px}
      `}</style>
    <Fade>
      <footer className="footer">
        <div className="footer-container">
          {/* About */}
          <div>
            <h3>STS Scope Tech</h3>
            <h5>Training and Development</h5>
            <p>
              STS, Madurai – Providing industry-standard training, real-time
              projects, and placement opportunities. We nurture talent in Full
              Stack Development, Embedded Systems, Creative Arts, and more.
            </p>
            <div className="social-icons">
              <Link to={'/'}><i className="fab fa-facebook-f"></i></Link>
              <Link to={'/'}><i className="fab fa-instagram"></i></Link>
              <Link to={'/'}><i className="fab fa-linkedin-in"></i></Link>
              <Link to={'/'}><i className="fab fa-youtube"></i></Link>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3>Quick Links</h3>
            <div className="footer-links">
              <Link to={'/home'}>Home</Link>
              <Link to={'/about'}>About Us</Link>
              <Link to={'/course'}>Training</Link>
              <Link to={'/placement'}>Placements</Link>
             
            </div>
          </div>

          {/* Courses */}
          <div>
            <h3>Quick Links</h3>
            <div className="footer-links">
               <Link to={'/review'}>Consultancy</Link>
              <Link to={'/review'}>Career</Link>
              <Link to={'/contact'}>Contact</Link>
            </div>
          </div>

          {/* Contact */}
         <div>
          
            <h3>Contact Us</h3>
            <h4>Branch 1</h4>
          <p>📍 16 / 1, Khalki Bhavan, Visuvasapuri 4th street, Gnanaolivaupuram, Madurai - 625016</p>
          <p>📞 +91 96009 36470</p>
          <p>✉️ scopetechsoftwaresolution@gmail.com</p>
    <p>🌐 scopetechsoftware.in</p>
  </div>

   <div className="b2">
          
           
            <h4>Branch 2</h4>
          <p>📍 4/275,Scope Tech Software Solution Iravathanallur,Standard Fire Box(Near) Madurai Ramnad Road - 625 009</p>
          <p>📞 +91 6383406578</p>
          <p>✉️ scopetechsoftwaresolution@gmail.com</p>
          
    <p>🌐 scopetechsoftware.in</p>
  </div>

        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          © {new Date().getFullYear()} STS | All Rights Reserved
        </div>
      </footer>
      </Fade>
    </>
  );
}
